import { createAction } from '@reduxjs/toolkit';
import { storeName } from '../config';

export const setHasDirtyForm = createAction<boolean>(
  `${storeName}/setHasDirtyForm`,
);
